export const NoLoanProgramsPopupTestIds = {
  SAVE_WITHOUT_PROGRAM_BUTTON: 'no-loan-programs-popup.save-without-program-button',
  CANCEL_BUTTON: 'no-loan-programs-popup.cancel-button',
};
